export const getIncludedAudioIds = (audios: TrqkGapChannelAudio[]): string[] =>
    audios.reduce(
        (
            acc: string[],
            { include, gap_audio_id }: TrqkGapChannelAudio,
        ): string[] => {
            if (include && gap_audio_id) {
                acc.push(gap_audio_id);
            }

            return acc;
        },
        [],
    );
